export default {
    // private
    dashboard: '/dashboard',
    profile: '/profile',
    security: '/security',
    licenses: '/licenses',
    subscriptions: '/subscriptions',
    support: '/support',
    messages: '/messages',

    // v2: new private routes
    credits: '/credits',
    purchaseHistory: '/purchases',
    orders: '/orders',
    verification: '/verification',
    healthSystems: '/healthsystems',
    notificationPrefs: '/notification-prefs',  // DSC-1A.2 — Wave 1 data-storage consolidation
    accountDisplayPrefs: '/display-prefs',     // DSC-1B.2 — Wave 1 data-storage consolidation
    abha: '/abha',                             // ABDM M1 — ABHA / Health ID management
    hpr: '/hpr',                               // ABDM M4 — HPR / Health Professional ID (doctors)

    // auth (Keycloak handles login/register/forgot-password, but kept for legacy compat)
    login: '/login',
    signup: '/signup',
    setUpUser:'/setupuser',
    forgotPassword: '/forgotpassword',
    policies:'/privacyPolicy',
    terms:'/terms',
    bookDemo:'/bookdemo',
    start:'/start',
    registration:'/Registration',
    updatePassword:'/UpdatePassword'
};
